import { createContext, useContext } from 'react';

import { INavigationConfig } from '~/src/dash/views/common';

interface IInventoryRulesListContext {
  cfg: INavigationConfig;
}

export const InventoryRulesListContext = createContext({} as IInventoryRulesListContext);
export const useInventoryRulesListStore = (): IInventoryRulesListContext =>
  useContext(InventoryRulesListContext);
